import axios from "axios";
import Qs from "qs";

const ROOT_URL = process.env.VUE_APP_ROOT_URL;
const AUTH_TOKEN = "AUTH-TOKEN";

function make_request_header() {
  return {
    "Content-Type": "application/json",
    "AUTH-TOKEN": get_auth_token(),
  };
}

function get_auth_token() {
  return localStorage.getItem(AUTH_TOKEN)
}

const client = () =>
  axios.create({
    baseURL: getBaseUrl(),
    headers: make_request_header(),
    paramsSerializer: function (params) {
      return Qs.stringify(params, {arrayFormat: 'brackets'})
    },
  });

export default client;

export function getBaseUrl() {
  // var current_url = window.location.href.split("//")
  // return `${current_url[0]}//${current_url[1].split('.')[0]}.${ROOT_URL}`
  return ROOT_URL
}
